module.exports = __webpack_public_path__ + "img/swipe.e792ed2c.svg";